<template>
  <div :class="$style.container">
    <component
      :is="currentView"
      :permission="permission"
      @declaration="handleDeclaration"
      @show-check="handleShowCheck"
    />
  </div>
</template>

<script>
import TransactionService from 'services/transaction';
import TransactionDeclarationService from 'services/transaction/declaration';

import { EVENT_BUS } from '@/eventBus';

const COMPONENTS_MAP = {
  ['DECLARE']: () => import('molecules/transaction/declaration/TransactionDeclare'),
  ['DECLARING']: () => import('molecules/transaction/declaration/TransactionDeclaring'),
  ['DECLARED']: () => import('molecules/transaction/declaration/TransactionDeclared'),
};

export default {
  name: 'TransactionDeclaration',
  props: {
    transaction: {
      type: Object,
      required: true,
    },
    permission: {
      type: Boolean,
      required: true,
    },
  },
  created() {
    EVENT_BUS.$on('EVENT_START_DECLARATION', this.handleDeclaration);
  },
  beforeDestroy() {
    EVENT_BUS.$off('EVENT_START_DECLARATION', this.handleDeclaration);
  },
  data() {
    return {
      status: this.getCurrentStatus(),
    };
  },
  computed: {
    currentView() {
      // DECLARE | DECLARING | DECLARED
      return COMPONENTS_MAP[this.status];
    },
  },
  methods: {
    getCurrentStatus() {
      if (TransactionDeclarationService.checkDeclared(this.transaction)) {
        return 'DECLARED';
      }

      return 'DECLARE';
    },
    async handleDeclaration() {
      const { description } = this.transaction;

      // если у транзакции отсутствует описание, необходимо запросить его у пользователя
      if (this.$validate.isNull(description)) {
        EVENT_BUS.$emit('EVENT_SHOW_SPECIFICATION_OF_DECLARATION_DESCRIPTION');
        return;
      }

      this.status = 'DECLARING';

      try {
        await TransactionDeclarationService.declaration({
          publicId: this.transaction.public_id,
          description: TransactionService.checkPartnerPayoutAccrual(this.transaction)
            ? 'Консультация и сопровождение' : description,
        });

        this.$alert({
          type: 'success',
          text: 'tax.office.know',
        });

        this.status = 'DECLARED';
      } catch (error) {
        this.$alert({
          type: 'warning',
          text: error.message,
        });

        this.status = 'DECLARE';
      }
    },
    handleShowCheck() {
      this.$router.push({
        name: 'transactionDeclaration',
        params: {
          publicId: this.transaction.public_id,
        },
      });
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +flexbox
    min-height: 40px
</style>
